import AsyncStorage from '@react-native-async-storage/async-storage';
import {BehaviorSubject} from 'rxjs';

class SearchStore {
  // 存储查询历史记录的数组
  private searchHistory: string[] = [];

  // 存储键名
  private readonly STORAGE_KEY = 'search_history';

  // 最大历史记录数量
  private maxHistorySize: number = 10;

  // 历史记录变更通知
  private historyChangeSubject = new BehaviorSubject<string[]>([]);

  // 添加新的查询记录
  addSearchQuery(query: string): void {
    // 避免空查询
    if (!query.trim()) return;

    // 如果查询已经存在，先移除它
    const index = this.searchHistory.indexOf(query);
    if (index !== -1) {
      this.searchHistory.splice(index, 1);
    }

    // 添加到历史记录的最前面
    this.searchHistory.unshift(query);

    // 如果超过最大记录数，删除最旧的
    if (this.searchHistory.length > this.maxHistorySize) {
      this.searchHistory.pop();
    }

    // 保存到本地存储
    this.saveToStorage();

    // 通知数据变更
    this.notifyHistoryChanged();
  }

  // 获取所有历史记录
  getSearchHistory(): string[] {
    return [...this.searchHistory];
  }

  // 清除所有历史记录
  clearSearchHistory(): void {
    this.searchHistory = [];
    this.saveToStorage();
    // 通知数据变更
    this.notifyHistoryChanged();
  }

  // 删除特定的历史记录
  removeSearchQuery(query: string): void {
    const index = this.searchHistory.indexOf(query);
    if (index !== -1) {
      this.searchHistory.splice(index, 1);
      this.saveToStorage();
      // 通知数据变更
      this.notifyHistoryChanged();
    }
  }

  // 将历史记录保存到本地存储
  private saveToStorage(): void {
    try {
      // 将数组转换为JSON字符串并保存到AsyncStorage
      AsyncStorage.setItem(
        this.STORAGE_KEY,
        JSON.stringify(this.searchHistory),
      ).catch(error => console.error('Failed to save search history', error));
    } catch (error) {
      console.error('Error serializing search history', error);
    }
  }

  // 从本地存储加载历史记录
  async loadFromStorage(): Promise<void> {
    try {
      const data = await AsyncStorage.getItem(this.STORAGE_KEY);
      if (data) {
        this.searchHistory = JSON.parse(data);
        // 通知数据变更
        this.notifyHistoryChanged();
      }
    } catch (error) {
      console.error('Failed to load search history', error);
    }
  }

  // 监听历史记录变更
  onHistoryChange(callback: (history: string[]) => void): {
    unsubscribe: () => void;
  } {
    return this.historyChangeSubject.subscribe(callback);
  }

  // 通知历史记录发生变更
  private notifyHistoryChanged(): void {
    this.historyChangeSubject.next([...this.searchHistory]);
  }
}

export const searchStore = new SearchStore();
